import Element, { IElementLayout } from '../../Prototype/UI/Element';
import ElementComponent from '../../Component/UI/Element';

export default class FutureStarChest extends Element {
    public create(params: { name: string; layout: Partial<IElementLayout>; tier: number; text: string }) {
        super.create({
            name: params.name,
            layout: params.layout,
            components: [
                {
                    type: 'image',
                    data: {
                        cacheKey: 'chest_bubble_bg',
                    },
                },
                {
                    type: 'input',
                    data: {
                        enabled: true,
                        buttonMode: true,
                        toggleable: true,
                        tintOnDisable: false,
                    },
                },
            ],
            children: [
                {
                    name: 'future_star_chest_text',
                    layout: {
                        anchors: [0.5, 0.6, 0.5, 0.6],
                        pivot: [0.5, 0.5],
                        offsets: [0, 3, 0, 3],
                        scale: [1, 1],
                    },
                    components: [
                        {
                            type: 'text',
                            data: {
                                text: params.text,
                                style: 'star_chest.future_chest_bubble',
                                align: 'center',
                                bounds: [125, 50],
                            },
                        },
                    ],
                },
            ],
        });
    }

    public updateAnchors(anchors: NonNullable<IElementLayout['anchors']>) {
        this.getComponent(ElementComponent).anchors = anchors;
    }
}
